import { render, staticRenderFns } from "./GpgPublicKeyDownloadBtn.vue?vue&type=template&id=2193a741&scoped=true"
import script from "./GpgPublicKeyDownloadBtn.vue?vue&type=script&lang=js"
export * from "./GpgPublicKeyDownloadBtn.vue?vue&type=script&lang=js"
import style0 from "./GpgPublicKeyDownloadBtn.vue?vue&type=style&index=0&id=2193a741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2193a741",
  null
  
)

export default component.exports